export default "__VITE_ASSET__BaS1j_BG__"